// Zipchat renders its search widget inside an open shadow root to isolate
// its styles from the page. base.css can't reach in there, so we inject our
// own override style directly into that shadow root once it appears.
(function () {
  const HOST_ID = 'zipchat-shadow-host';
  const STYLE_ID = 'zipchat-theme-overrides';

  const overrideCss = `
    .zipchat-search-bar-wrapper::after,
    .zipchat-search-modal-wrapper::after {
      background: none !important;
    }
    .zipchat-search-bar {
      padding: 24px 32px !important;
    }
    .zipchat-search-modal {
      background: #f8f8f6 !important;
    }
  `;

  function injectOverride(shadowRoot) {
    if (shadowRoot.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = overrideCss;
    shadowRoot.appendChild(style);
  }

  function tryInject() {
    const host = document.getElementById(HOST_ID);
    if (host && host.shadowRoot) {
      injectOverride(host.shadowRoot);
      return true;
    }
    return false;
  }

  if (tryInject()) return;

  const observer = new MutationObserver(() => {
    if (tryInject()) observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
